import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { isTestingToolsEnabled } from '@/lib/testingTools';

export const Route = createFileRoute('/_authenticated/_testing-tools')({
  beforeLoad: () => {
    if (!isTestingToolsEnabled()) {
      throw redirect({ to: '/' });
    }
  },
  component: Outlet,
});
